/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button, Icon, Input, InputLabel, Select } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import React, { useEffect, useRef, useState } from 'react';
import descriptors from '../../locales/en-US/descriptors';
import { MAGIC_VALUE } from '../shared/Utils/Constants';
import {
  IUtilityFormProps,
  consumptionUnitOptions,
  demandUnitOption,
  currencyUnitOption,
  IUtilityFormEditDetailProps,
  consumptionUnitOptionsForGas,
  consumptionUnitOptionsForWaterSewer
} from './IUtilityService';
import { ToastNotification } from './Notification';
import './ConnectTab/ConnectTab.scss';
import { SpecialCharacter } from '../shared/Utils/Utils';
import {
  EMaaSNotificationCheck,
  setPassword,
  setUsername,
  validate
} from './ConnectTab/ConnectTabUtils';
import { DataTable } from '@scuf/datatable';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import { useUtilityAccountContext } from '../../context/UtilityAccountContext/UtilityAccountContext';

function EditDetailsutilityform(props: IUtilityFormEditDetailProps) {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const {
    setAccUtility,
    accUtility,
    addUtilityTable,
    setAddUtilityTable,
    utilityTyp,
    manualAccountUtility,
    setManualAccountUtility,
    isDataAvailablebill,
    setSubmitDisabled
  } = props;
  let { isSubmitted } = props;
  const [isDisabled, setDisabled] = useState(true);
  const [manualDisabled, setManualDisabled] = useState(true);
  const [meterLinkDisabled, setMeterLinkDisabled] = useState(true);
  const [isGas, setIsGas] = useState<boolean>(false);
  const [isWaterSewer, setIsWaterSewer] = useState<boolean>(false);
  const emptyMeter = {
    meterNumber: '',
    meterName: '',
    meterId: null,
    utilityMeterDetailsId: null
  };
  const [state, dispatch] = useUtilityAccountContext();
  const {
    showModal,
    showConversionModal,
    selectedUtility,
    editDetailsModal
  } = state;

  const initialDetails = {
    accountNumber: selectedUtility.accountNumber,
    utility: selectedUtility.utilityType,
    consumptionUnit: selectedUtility.consumptionUnit,
    demandUnit: selectedUtility.demandUnit,
    currencyUnit: selectedUtility.currencyUnit,
    utilityAccountId: selectedUtility.utilityAccountId,
    manualMeterDetails: selectedUtility.meterDetails.map((meter: any) => ({
      meterNumber: meter.meterNumber,
      meterName: meter.meterName,
      meterId: meter.meterId,
      utilityMeterDetailsId: meter.utilityMeterDetailsId
    }))
  };
  const [manualAccountDetails, setManualAccountDetails] = useState(
    initialDetails
  );
  const [utility, setutility] = useState(selectedUtility.utilityType);
  const [accountnumber, setaccountnumber] = useState(
    selectedUtility.accountNumber
  );
  const [currencyunit, setcurrencyunit] = useState(
    selectedUtility.currencyUnit
  );
  const [demandunit, setdemandunit] = useState(selectedUtility.demandUnit);
  const [consumptionunit, setconsumptionunit] = useState(
    selectedUtility.consumptionUnit
  );

  useEffect(() => {
    setIsGas(
      manualAccountDetails.utility === 'Electricity'
        ? false
        : ['Water', 'Sewer'].includes(manualAccountDetails.utility)
        ? false
        : true
    );
    setIsWaterSewer(
      ['Water', 'Sewer'].includes(manualAccountDetails.utility) ? true : false
    );
  }, []);

  const utilityOptionsManualForGas = [
    {
      text: 'Electricity',
      value: 'Electricity'
    },
    // {
    //   text: 'Water',
    //   value: JSON.stringify({
    //     name: 'Water',
    //     id: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B'
    //   })
    // },
    {
      text: 'Gas',
      value: 'Gas'
    }
    // {
    //   text: 'Sewer',
    //   value: JSON.stringify({
    //     name: 'Sewer',
    //     id: 'DE8FFAD6-E4BD-4809-8C96-9B980FAA62EF'
    //   })
    // }
  ];

  const utilityOptionsManualForWaterSewer = [
    {
      text: 'Electricity',
      value: 'Electricity'
    },
    {
      text: 'Water',
      value: 'Water'
    },
    {
      text: 'Sewer',
      value: 'Sewer'
    },
    // {
    //   text: 'Water',
    //   value: JSON.stringify({
    //     name: 'Water',
    //     id: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B'
    //   })
    // },
    {
      text: 'Gas',
      value: 'Gas'
    }
    // {
    //   text: 'Sewer',
    //   value: JSON.stringify({
    //     name: 'Sewer',
    //     id: 'DE8FFAD6-E4BD-4809-8C96-9B980FAA62EF'
    //   })
    // }
  ];

  const utilityOptionsManualForWater = [
    {
      text: 'Electricity',
      value: 'Electricity'
    },
    {
      text: 'Water',
      value: 'Water'
    },
    // {
    //   text: 'Water',
    //   value: JSON.stringify({
    //     name: 'Water',
    //     id: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B'
    //   })
    // },
    {
      text: 'Gas',
      value: 'Gas'
    }
    // {
    //   text: 'Sewer',
    //   value: JSON.stringify({
    //     name: 'Sewer',
    //     id: 'DE8FFAD6-E4BD-4809-8C96-9B980FAA62EF'
    //   })
    // }
  ];

  const utilityOptionsManual = [
    {
      text: 'Electricity',
      value: 'Electricity'
    }
    // {
    //   text: 'Water',
    //   value: JSON.stringify({
    //     name: 'Water',
    //     id: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B'
    //   })
    // },
    // {
    //   text: 'Gas',
    //   value: JSON.stringify({
    //     name: 'Gas',
    //     id: '344F9FD4-B18B-4B4A-A654-D9D9015A1CC3'
    //   })
    // }
    // {
    //   text: 'Sewer',
    //   value: JSON.stringify({
    //     name: 'Sewer',
    //     id: 'DE8FFAD6-E4BD-4809-8C96-9B980FAA62EF'
    //   })
    // }
  ];

  const { manualMeterDetails } = manualAccountDetails;

  const checkForSpecialCharacter = (text: string) =>
    text.replace(new RegExp(/[`@.!#$%^&*()+\-=\[\]{};':"\\|,<>\/?~]/, 'g'), '');
  useEffect(() => {
    let allmeterPresent = false;
    manualMeterDetails.map((m: any) => {
      if (m.meterName === '' || m.meterNumber === '') {
        allmeterPresent = true;
        // setMeterLinkDisabled(true);
      }
      // else {
      //   setMeterLinkDisabled(false);
      // }
    });
    setMeterLinkDisabled(allmeterPresent);
  }, [manualMeterDetails]);

  useEffect(() => {
    let allmeterPresent = false;
    manualMeterDetails.map((m: any) => {
      if (m.meterName === '' || m.meterNumber === '') {
        allmeterPresent = true;
        // setMeterLinkDisabled(true);
      }
      // else {
      //   setMeterLinkDisabled(false);
      // }
    });
    selectedUtility.integrationType !== 'Automatic' &&
      setSubmitDisabled(allmeterPresent);
  }, [manualMeterDetails]);

  useEffect(() => {
    isSubmitted = props.isSubmitted;
  }, [props]);

  const renderMeterNumber = (row: ICellData) => {
    return (
      <span>{`${row.rowData.meterName} (${row.rowData.meterNumber})`}</span>
    );
  };

  // const MaxAccountLimit = 10;

  const isAllMeterPresent = () => {
    let meterDataAbsent = false;
    manualMeterDetails.forEach((mtr: any) => {
      if (mtr.meterName === '' || mtr.meterNumber === '') {
        meterDataAbsent = true;
      }
    });
    return meterDataAbsent;
  };

  useEffect(() => {
    const { accountNumber, utility, manualMeterDetails } = manualAccountDetails;
    if (
      accountNumber === '' ||
      (!(selectedUtility.integrationType === 'Automatic') &&
        (utility === '' ||
          isAllMeterPresent() ||
          !manualAccountDetails.consumptionUnit ||
          (manualMeterDetails && manualMeterDetails.length === 0)))
    ) {
      setManualDisabled(true);
      //setSubmitDisabled(true);
    } else {
      setSubmitDisabled(false);
      setManualDisabled(false);
    }
  }, [manualAccountDetails]);

  useEffect(() => {
    let checkAccount =
      accUtility.accountNumber === '' || accUtility.accountNumber === undefined;
    let checkUtility =
      accUtility.utility === '' || accUtility.utility === undefined;
    if (checkAccount || checkUtility) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [accUtility]);

  const renderAccountNumber = () => {
    return (
      <Input
        className="edit-detail-account-number"
        maxlength={20}
        type="text"
        placeholder={selectedUtility.accountNumber}
        label={t(d.ACCNUMBER)}
        // disabled={isDataAvailablebill?.length == 0 ? false : true}
        value={manualAccountDetails.accountNumber}
        onChange={(value) => handleManualDetails(value, 'accountNumber')}
      />
    );
  };

  const renderUtilityType = () => {
    return (
      <div className={'utility'}>
        <InputLabel
          className="utility-label"
          label={t(d.UtilityTypeforselectutility)}
        />
        <Select
          placeholder={selectedUtility.utilityType}
          options={
            props.emaasContext.toggleGasManageBill &&
            props.emaasContext.toggleManualWaterSewer
              ? utilityOptionsManualForWaterSewer
              : props.emaasContext.toggleGasManageBill &&
                props.emaasContext.toggleManualWater
              ? utilityOptionsManualForWater
              : props.emaasContext.toggleGasManageBill
              ? utilityOptionsManualForGas
              : utilityOptionsManual
          }
          disabled={
            selectedUtility.integrationType === 'Automatic'
              ? true
              : isDataAvailablebill?.length == 0
              ? false
              : true
          }
          value={manualAccountDetails.utility}
          onChange={(value) => handleManualDetails(value, 'utility')}
        />
      </div>
    );
  };

  const handleManualDetails = (value: IAny, name: string) => {
    // setManualAccountDetails({ ...manualAccountDetails, [name]: value });
    if (name === 'utility') {
      setManualAccountDetails((prevD) => ({
        ...prevD,
        ['consumptionUnit']: ''
      }));
      if (value === 'Water' || value === 'Sewer') {
        setIsWaterSewer(true);
      } else {
        setIsWaterSewer(false);
      }
      if (value === 'Gas') {
        setIsGas(true);
      } else {
        setIsGas(false);
      }
    }
    setManualAccountDetails((prevD) => ({ ...prevD, [name]: value }));
  };

  const AddManualMeters = () => {
    if (manualAccountDetails.manualMeterDetails.length) {
      setMeterLinkDisabled(true);
      setSubmitDisabled(true);
      let details = manualAccountDetails.manualMeterDetails;
      details.push(emptyMeter);
      setManualAccountDetails({
        ...manualAccountDetails,
        manualMeterDetails: details
      });
    }
  };
  useEffect(() => {
    if (isDataAvailablebill?.length > 0) {
      const temp = JSON.parse(JSON.stringify(manualAccountDetails));
      temp.manualMeterDetails = temp.manualMeterDetails.map((mtr: IAny) => {
        return { ...mtr, alreadyExists: true };
      });
      setManualAccountDetails(temp);
    }
  }, [isDataAvailablebill]);
  useEffect(() => {
    setManualAccountUtility([manualAccountDetails]);
  }, [manualAccountDetails]);

  const removeMeter = (key: number) => {
    let tempAccountDetails = [...manualAccountDetails.manualMeterDetails];
    tempAccountDetails.splice(key, 1);
    setManualAccountDetails({
      ...manualAccountDetails,
      manualMeterDetails: tempAccountDetails
    });
  };

  const handleMeterNumber = (value: string, index: number) => {
    if (value.length <= MAGIC_VALUE.HUNDRED && !SpecialCharacter(value)) {
      let tempAccountDetails = [...manualAccountDetails.manualMeterDetails];
      tempAccountDetails[index].meterNumber = value;
      setManualAccountDetails({
        ...manualAccountDetails,
        manualMeterDetails: tempAccountDetails
      });
    }
  };

  const handleMeterName = (value: string, index: number) => {
    if (value.length <= MAGIC_VALUE.HUNDRED && !SpecialCharacter(value)) {
      let tempAccountDetails = [...manualAccountDetails.manualMeterDetails];
      tempAccountDetails[index].meterName = value;
      setManualAccountDetails({
        ...manualAccountDetails,
        manualMeterDetails: tempAccountDetails
      });
    }
  };

  const isGasWaterSewer = isGas || isWaterSewer;

  const styleForAutomaticEditAccountNumber =
    selectedUtility.integrationType === 'Automatic'
      ? 'Automatic-EditAccnt'
      : 'meter-input-fields-account-input';
  const styleForAutomaticUtilityType =
    selectedUtility.integrationType === 'Automatic'
      ? 'manual-utility Automatic-EditUtilityType'
      : 'manual-utility';
  const styleAccountDetailsForAutomatic =
    selectedUtility.integrationType === 'Automatic'
      ? 'account-details Automatic-Account-Details'
      : 'account-details';
  return (
    <div className="edit-detail-form-container">
      {utilityTyp === 'Manual' && (
        <React.Fragment>
          <div className={styleAccountDetailsForAutomatic}>
            <div className={styleForAutomaticEditAccountNumber}>
              {renderAccountNumber()}
            </div>
            <div className={styleForAutomaticUtilityType}>
              {renderUtilityType()}
            </div>
          </div>
          {selectedUtility.integrationType !== 'Automatic' && (
            <div
              className={
                isGasWaterSewer
                  ? 'manual-utility-fields-water-sewer'
                  : 'manual-utility-fields'
              }
            >
              <div className="consumption-field">
                <InputLabel
                  className="utility-label"
                  label={t(d.CONSUMPTIONUNIT) + '*'}
                />
                <Select
                  options={
                    isGas
                      ? consumptionUnitOptionsForGas
                      : isWaterSewer
                      ? consumptionUnitOptionsForWaterSewer
                      : consumptionUnitOptions
                  }
                  value={manualAccountDetails.consumptionUnit}
                  onChange={(value) =>
                    handleManualDetails(value, 'consumptionUnit')
                  }
                  disabled={isDataAvailablebill?.length == 0 ? false : true}
                />
              </div>
              {!isGas && !isWaterSewer && (
                <div className="demand-field">
                  <InputLabel
                    className="utility-label"
                    label={t(d.DEMANDUNIT)}
                  />
                  <Select
                    options={demandUnitOption}
                    value={manualAccountDetails.demandUnit}
                    onChange={(value) =>
                      handleManualDetails(value, 'demandUnit')
                    }
                    disabled={isDataAvailablebill?.length == 0 ? false : true}
                  />
                </div>
              )}

              <div className="currency-field">
                <InputLabel
                  className="utility-label"
                  label={t(d.CURRENCYUNIT) + '*'}
                />
                <Select
                  options={currencyUnitOption}
                  value={manualAccountDetails.currencyUnit}
                  onChange={(value) =>
                    handleManualDetails(value, 'currencyUnit')
                  }
                  disabled={isDataAvailablebill?.length == 0 ? false : true}
                />
              </div>
            </div>
          )}
          {selectedUtility.integrationType !== 'Automatic' &&
            manualAccountDetails.manualMeterDetails.map(
              (meter: any, key: any) => {
                return (
                  <React.Fragment key={`account-${key}`}>
                    <div className="meter-input-fields">
                      <div className="meter-number-input">
                        <Input
                          className="meter-number"
                          type="text"
                          value={
                            meter.meterNumber
                            //   checkForSpecialCharacter(
                            //   meter.meterNumber?.toString()
                            // )
                          }
                          onChange={(value) =>
                            handleMeterNumber(
                              checkForSpecialCharacter(value),
                              key
                            )
                          }
                          label={t(d.METERNUMBER)}
                          // disabled={meter.alreadyExists}
                        />
                      </div>
                      <div className="meter-name-input">
                        <Input
                          className="meter-name"
                          type="text"
                          value={checkForSpecialCharacter(meter.meterName)}
                          onChange={(value) =>
                            handleMeterName(
                              checkForSpecialCharacter(value),
                              key
                            )
                          }
                          label={t(d.METERNAME)}
                          // disabled={meter.alreadyExists}
                        />
                      </div>
                      {!meter.alreadyExists && (
                        <div className="remove">
                          <Button
                            onClick={() => removeMeter(key)}
                            type="link"
                            icon={<Icon name="close" root="common" />}
                            content=""
                            disabled={meter.alreadyExists}
                          />
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                );
              }
            )}
          {selectedUtility.integrationType !== 'Automatic' && (
            <div className="add-meter-link">
              <Button
                className="add-meter"
                type="link"
                icon={<Icon name="badge-plus" root="common" />}
                onClick={() => {
                  AddManualMeters();
                }}
                content={t(d.ADD_METERS)}
                disabled={
                  meterLinkDisabled
                  // || manualAccountDetails?.manualMeterDetails?.length > 9
                }
              />
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
}
export default EditDetailsutilityform;
